<template>
  <div class="grid">
    <div class="col-12">
      <div class="card" v-if="permission?.includes('read')">
        <Toast />
        <Error :errors="errors" />

        <Fieldset
          legend="Filter"
          :toggleable="true"
          :collapsed="true"
          class="mb-3"
        >
          <Filter @submit="getDataTable()" ref="filter" />
        </Fieldset>

        <DataTable
          :value="dataTable"
          responsiveLayout="scroll"
          :loading="loading"
          dataKey="number"
          @sort="onSort($event)"
          :resizableColumns="true"
        >
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <div>
                <Button
                  :loading="loadingExcel"
                  label="Export Excel"
                  icon="pi pi-file-excel"
                  class="p-button p-button-success mr-2 my-1 inline-block"
                  @click="exportExcelCSV('xlsx')"
                />
                <Button
                  :loading="loadingCsv"
                  label="Export CSV"
                  icon="pi pi-file-excel"
                  class="p-button p-button-success mr-2 my-1 inline-block"
                  @click="exportExcelCSV('csv')"
                />
              </div>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="search"
                  placeholder="Cari..."
                  @keyup.enter="getDataTable"
                />
              </span>
            </div>
          </template>
          <Column field="number" header="No." :style="{ width: '20px' }">
            <template #body="slotProps">
              {{ slotProps.data.number }}
            </template>
          </Column>
          <Column field="region_name" header="Region">
            <template #body="slotProps">
              {{ slotProps.data.region_name }}
            </template>
          </Column>
          <Column field="distributor_code" header="Distributor Code">
            <template #body="slotProps">
              {{ slotProps.data.distributor_code }}
            </template>
          </Column>
          <Column field="distributor_name" header="Distributor Name">
            <template #body="slotProps">
              {{ slotProps.data.distributor_name }}
            </template>
          </Column>
          <Column field="user_code" header="ASM Code">
            <template #body="slotProps">
              {{ slotProps.data.user_code }}
            </template>
          </Column>
          <Column field="user_name" header="ASM Name">
            <template #body="slotProps">
              {{ slotProps.data.user_name }}
            </template>
          </Column>
          <Column field="salesman_code" header="Salesman Code">
            <template #body="slotProps">
              {{ slotProps.data.salesman_code }}
            </template>
          </Column>
          <Column field="salesman_name" header="Salesman Name">
            <template #body="slotProps">
              {{ slotProps.data.salesman_name }}
            </template>
          </Column>
          <Column field="outlet_code" header="Outlet Code">
            <template #body="slotProps">
              {{ slotProps.data.outlet_code }}
            </template>
          </Column>
          <Column field="outlet_name" header="Outlet Name">
            <template #body="slotProps">
              {{ slotProps.data.outlet_name }}
            </template>
          </Column>
          <Column field="call_type" header="Call Type">
            <template #body="slotProps">
              {{ slotProps.data.call_type }}
            </template>
          </Column>
          <Column field="extra_call_reason" header="Extra Call Reason">
            <template #body="slotProps">
              {{ slotProps.data.extra_call_reason }}
            </template>
          </Column>
          <Column field="beat_id" header="Beat">
            <template #body="slotProps">
              {{ slotProps.data.beat_id }}
            </template>
          </Column>
          <Column field="reason_name" header="Outside 50 M">
            <template #body="slotProps">
              {{ slotProps.data.reason_name }}
            </template>
          </Column>
          <Column field="coaching_date" header="Coaching Date">
            <template #body="slotProps">
              {{ slotProps.data.coaching_date }}
            </template>
          </Column>
          <Column field="coaching_start" header="Coaching Start">
            <template #body="slotProps">
              {{ slotProps.data.coaching_start }}
            </template>
          </Column>
          <Column field="coaching_end" header="Coaching End">
            <template #body="slotProps">
              {{ slotProps.data.coaching_end }}
            </template>
          </Column>
          <Column field="coaching_duration" header="Coaching Duration">
            <template #body="slotProps">
              {{ slotProps.data.coaching_duration }}
            </template>
          </Column>
          <Column field="coaching_longitude" header="Coaching Longitude">
            <template #body="slotProps">
              {{ slotProps.data.coaching_longitude }}
            </template>
          </Column>
          <Column field="coaching_latitude" header="Coaching Latitude">
            <template #body="slotProps">
              {{ slotProps.data.coaching_latitude }}
            </template>
          </Column>
          <Column field="jarak_meter" header="Jarak (meter)">
            <template #body="slotProps">
              {{ slotProps.data.jarak_meter }}
            </template>
          </Column>
          <Column field="coaching_gps_address" header="Coaching GPS Address">
            <template #body="slotProps">
              {{ slotProps.data.coaching_gps_address }}
            </template>
          </Column>
          <Column field="target_sales" header="Target Sales">
            <template #body="slotProps">
              {{ slotProps.data.target_sales }}
            </template>
          </Column>
          <Column field="target_ec" header="Target EC">
            <template #body="slotProps">
              {{ slotProps.data.target_ec }}
            </template>
          </Column>
          <Column field="preparation" header="Preparation">
            <template #body="slotProps">
              {{ slotProps.data.preparation }}
            </template>
          </Column>
          <Column field="opening" header="Opening">
            <template #body="slotProps">
              {{ slotProps.data.opening }}
            </template>
          </Column>
          <Column field="check_stock" header="Check Stock">
            <template #body="slotProps">
              {{ slotProps.data.check_stock }}
            </template>
          </Column>
          <Column field="merchandising" header="Merchandising">
            <template #body="slotProps">
              {{ slotProps.data.merchandising }}
            </template>
          </Column>
          <Column field="sales_presentation" header="Sales Presentation">
            <template #body="slotProps">
              {{ slotProps.data.sales_presentation }}
            </template>
          </Column>
          <Column field="sales_closing" header="Sales Closing">
            <template #body="slotProps">
              {{ slotProps.data.sales_closing }}
            </template>
          </Column>
          <Column field="sales_tracking" header="Sales Tracking">
            <template #body="slotProps">
              {{ slotProps.data.sales_tracking }}
            </template>
          </Column>
          <Column field="pvmi" header="PVMI Total">
            <template #body="slotProps">
              {{ slotProps.data.pvmi }}
            </template>
          </Column>
          <Column field="pvmi_msl" header="PVMI MSL">
            <template #body="slotProps">
              {{ slotProps.data.pvmi_msl }}
            </template>
          </Column>
          <Column field="pvmi_strategic" header="PVMI Strategic">
            <template #body="slotProps">
              {{ slotProps.data.pvmi_strategic }}
            </template>
          </Column>
          <Column field="mayora" header="Mayora">
            <template #body="slotProps">
              {{ slotProps.data.mayora }}
            </template>
          </Column>
          <Column field="unifarm" header="Unifarm">
            <template #body="slotProps">
              {{ slotProps.data.unifarm }}
            </template>
          </Column>
          <Column field="yupi" header="Yupi">
            <template #body="slotProps">
              {{ slotProps.data.yupi }}
            </template>
          </Column>
          <Column field="outlet_photo" header="Photo Outlet"> </Column>
          <Column field="posm_implementation_url" header="POSM Implementation">
            <template #body="slotProps">
              <Image
                v-if="slotProps.data.posm_implementation_url != 'null'"
                :src="slotProps.data.posm_implementation_url"
                :alt="slotProps.data.posm_implementation_url"
                width="100"
                preview
              />
            </template>
          </Column>
          <Column field="competitor_activity_url" header="Competitor Activity">
            <template #body="slotProps">
              <Image
                v-if="slotProps.data.competitor_activity_url != 'null'"
                :src="slotProps.data.competitor_activity_url"
                :alt="slotProps.data.competitor_activity_url"
                width="100"
                preview
              />
            </template>
          </Column>
          <Column field="feedback" header="Feedback">
            <template #body="slotProps">
              {{ slotProps.data.feedback }}
            </template>
          </Column>
          <Column field="sales_actual" header="Actual Sales">
            <template #body="slotProps">
              {{ slotProps.data.sales_actual }}
            </template>
          </Column>
          <Column field="ec_actual" header="Actual EC">
            <template #body="slotProps">
              {{ slotProps.data.ec_actual }}
            </template>
          </Column>
          <Column
            field="feedback_coaching_session"
            header="Feedback Coaching Session"
          >
            <template #body="slotProps">
              {{ slotProps.data.feedback_coaching_session }}
            </template>
          </Column>

          <template #empty> No data found. </template>
          <template #loading> Loading data. Please wait. </template>
          <template #footer>
            In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
          </template>
        </DataTable>

        <Paginator
          v-model:rows="rows"
          v-model:first="offset"
          :totalRecords="totalItemsCount"
          :rowsPerPageOptions="[10, 20, 30]"
        >
          <template>
            {{ totalItemsCount }}
          </template>
        </Paginator>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Filter from "../../components/report/coaching/Filter.vue";
import Error from "../../components/Error.vue";

export default {
  components: {
    Filter: Filter,
    Error: Error,
  },
  data() {
    return {
      // loading
      loading: false,
      loadingExcel: false,
      loadingCsv: false,

      //datatables
      data: null,
      dataTable: null,
      rows: 10,
      search: null,
      offset: null,
      field: null,
      sort: null,
      page: null,
      totalItemsCount: 0,
    };
  },
  mounted() {
    const waitForRef = setInterval(() => {
      if (this.$refs.filter) {
        clearInterval(waitForRef);
        this.getDataTable();
      }
    }, 100);
    this.$store.commit("setErrors", {});
  },
  watch: {
    offset() {
      this.getDataTable();
    },
    rows() {
      this.getDataTable();
    },
  },
  computed: {
    ...mapGetters(["errors"]),
    ...mapGetters("auth", ["permission"]),
  },
  methods: {
    formatDate(value) {
      if (value) {
        return moment.utc(value).format("DD-MM-YYYY");
      }
    },
    // DATATABLE
    getDataTable() {
      this.loading = true;
      if (this.$refs?.filter) {
        this.$refs.filter.loading = true;
      }
      this.page = this.offset / this.rows + 1;

      this.axios({
        method: "GET",
        url: process.env.VUE_APP_ROOT_API + "web/coaching",
        params: {
          search: this.search,
          per_page: this.rows,
          page: this.page,
          order_by: this.field,
          sort_by: this.sort,
          region_id: this.$refs?.filter?.filters.region_id,
          distributor_id: this.$refs?.filter?.filters.distributor_id,
          user_code: this.$refs?.filter?.filters.user_code,
          start_date: this.$refs?.filter?.period_start_label,
          end_date: this.$refs?.filter?.period_end_label,
        },
      })
        .then((res) => {
          this.data = res.data.data.data;
          this.dataTable = numberingDatatable(
            res.data.data.data,
            this.page,
            this.rows,
          );
          this.totalItemsCount = res.data.data.total;
          this.rows = parseInt(res.data.data.per_page);
          this.loading = false;
          this.$refs.filter.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$refs.filter.loading = false;
        });
    },
    onSort(event) {
      this.field = event.sortField;
      this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
      this.getDataTable();
    },
    // EXPORT
    exportExcelCSV(ext) {
      if (
        this.$refs?.filter?.period_start_label !== null &&
        this.$refs?.filter?.period_end_label !== null &&
        this.$refs?.filter?.period_start_label !== "Invalid date" &&
        this.$refs?.filter?.period_end_label !== "Invalid date"
      ) {
        if (ext == "xlsx") {
          this.loadingExcel = true;
        } else if (ext == "csv") {
          this.loadingCsv = true;
        }

        this.axios({
          method: "GET",
          url: process.env.VUE_APP_ROOT_API + "web/coaching/export",
          responseType: "blob",
          params: {
            ext: ext,
            region_id: this.$refs?.filter?.filters.region_id,
            distributor_id: this.$refs?.filter?.filters.distributor_id,
            user_code: this.$refs?.filter?.filters.user_code,
            start_date: this.$refs?.filter?.period_start_label,
            end_date: this.$refs?.filter?.period_end_label,
          },
        })
          .then((response) => {
            let fileUrl = window.URL.createObjectURL(response.data);
            let fileLink = document.createElement("a");

            fileLink.href = fileUrl;

            fileLink.setAttribute("download", "Report Coaching Export." + ext);

            document.body.appendChild(fileLink);

            fileLink.click();

            if (ext == "xlsx") {
              this.loadingExcel = false;
            } else if (ext == "csv") {
              this.loadingCsv = false;
            }
          })
          .catch((err) => {
            console.log(err);

            if (ext == "xlsx") {
              this.loadingExcel = false;
            } else if (ext == "csv") {
              this.loadingCsv = false;
            }
          });
      } else {
        alert("Pastikan rentang waktu sudah benar atau tidak kosong");
      }
    },
  },
};
</script>
